import { Editor } from "slate";

const insertPlainText = (editor: Editor, text: string) => {
  return Editor.insertText(editor, text);
};

export default insertPlainText;
